import React from 'react'
import { graphql} from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

import { renderRichText } from "gatsby-source-contentful/rich-text"
import styled from "@emotion/styled"

import Layoutwfooter from '../components/layoutwfooter'
import Content from '../components/content'
import Title from '../components/title'

const Textblock = styled.div`
background-color: #fff;
padding: 18px 0 0 0;
span {
    font-size: .9125rem;
    letter-spacing: 2px;
    font-weight: 800;
}
h3 {
  padding-bottom: 1vh;
}
`
const Titling = styled.div`
padding-bottom: 2vh;
h3 {
    font-weight: 400;
    padding-top: .5vh;
    letter-spacing: .5px;
    font-size: .75rem;
    color: rgba(0,0,0,0.66);
}
`
const Sidebar = styled.div`
img {
  width: 18.5vw;
  height: 18.5vw;
}
`

const News = ({ data }) => {
    return (
      <>
      <Layoutwfooter>
          <Content>
              <Textblock>
              <Titling><Title>{data.single.title}</Title><h3>{data.single.date}</h3></Titling>
              {renderRichText(data.single.body)}
              </Textblock>
              <Sidebar>
                <GatsbyImage image={data.single.image.gatsbyImageData} alt="image" objectFit="cover" />
              </Sidebar>
          </Content>
      </Layoutwfooter>
      </>
  )
}

export const query = graphql`
query ($slug: String) {
  single: contentfulNews(slug: {eq: $slug}) {
    id
    title
    date(formatString:"MMM D, YYYY")
    image {
      gatsbyImageData
    }
    slug
    body {
      raw
    }
  }
}
`

export default News